import { MediaRef } from "../image/enhanced-image/types/types";
import { MutableShowroom } from "./model/types";
import { createContext, ReactNode, useContext } from "react";

interface ShowroomContextTypes {
    content: MutableShowroom;
    isEditing: boolean;
    setTitle: (title: string) => void;
    setSubtitle: (subtitle: string) => void;
    setDescription: (description: string) => void;
    setImages: (images: MediaRef[]) => void;
}

const ShowroomContext = createContext<ShowroomContextTypes | undefined>(undefined);

export function useShowroom() {
    const context = useContext(ShowroomContext);
    if (!context) {
        throw new Error("useShowroom must be used within a ShowroomProvider");
    }
    return context;
}

interface ShowroomProviderProps {
    content: MutableShowroom;
    isEditing: boolean;
    setTitle: (title: string) => void;
    setSubtitle: (subtitle: string) => void;
    setDescription: (description: string) => void;
    setImages: (images: MediaRef[]) => void;
    children: ReactNode;
}

export function ShowroomProvider({ content, isEditing, setTitle, setSubtitle, setDescription, setImages, children }: ShowroomProviderProps) {
    return (
        <ShowroomContext.Provider value={{
            content,
            isEditing,
            setTitle,
            setSubtitle,
            setDescription,
            setImages
        }}>
            {children}
        </ShowroomContext.Provider>
    );
}